import $ from "jquery"
import { each } from "lodash"
import ControlView from "views/control_view"

// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
let SuperLightboxView

const FOCUSABLE_ELEMENTS =
  'button:not(:disabled), [href], input:not(:disabled):not([type="hidden"]), select:not(:disabled), textarea:not(:disabled), [tabindex]:not([tabindex="-1"])'

// Represents a lightbox which can be closed by clicking it.
export default SuperLightboxView = (function () {
  SuperLightboxView = class SuperLightboxView extends ControlView {
    static initClass() {
      this.prototype.className = "lightbox"
      this.prototype.tagName = "section"

      this.prototype.leaveWhenEscapePressed = true
      this.prototype.leaveWhenMaskClicked = true
      this.prototype.escapeKeyCode = 27
      this.prototype.attributes = {
        role: "dialog",
        "aria-modal": "true",
        tabindex: "-1",
      }
    }

    initialize(options) {
      this._handleMaskMouseDown = this._handleMaskMouseDown.bind(this)
      this._click = this._click.bind(this)
      this._keydown = this._keydown.bind(this)
      this._trapFocus = this._trapFocus.bind(this)
      if (options == null) {
        options = {}
      }
      this.bindings = []
      this.maskMouseDownStartedOnMask = false
      this._bindTo($(document), "keydown", this._keydown)
      this._bindTo($(document), "keydown", this._trapFocus)
      this.$el.on("mousedown", this._handleMaskMouseDown)
      this.$el.on("click", this._click)
      this.build()
      return super.initialize(options)
    }

    build() {
      this.$innerEl = $('<div class="lightbox-inner" role="document"></div>').appendTo(this.el)
      this.innerEl = this.$innerEl.get(0)
      return $("body").addClass("lightbox-open")
    }

    close() {
      this._unbindFromAll()
      this.off()
      this.remove()

      // If the place user was previously focused is still around in the DOM and visible
      // focus it again (usually the button that opens the lightbox)
      if (this.previousFocus && document.contains(this.previousFocus)) {
        const $previous = $(this.previousFocus)

        if ($previous.is(":visible")) {
          $previous.focus()
        }
      }
      return $("body").removeClass("lightbox-open")
    }

    show(e) {
      super.show(e)

      this.focusLightbox()
    }

    focusLightbox() {
      this.previousFocus = document.activeElement
      this.$el.focus()
    }

    _handleMaskMouseDown(event) {
      this.maskMouseDownStartedOnMask = $(event.target).is(".lightbox")
    }

    // Hide the lightbox if it is clicked.
    _click(event) {
      const $el = $(event.target)
      const href = $el.attr("href")
      if (href && href === "#") {
        event.preventDefault()
      }

      const shouldLeave =
        this.leaveWhenMaskClicked &&
        this.maskMouseDownStartedOnMask &&
        $el.is(".lightbox") &&
        this.isVisible()

      this.maskMouseDownStartedOnMask = false

      if (shouldLeave) {
        return this._leave()
      }
    }

    // Hide the lightbox if escape is pressed.
    _keydown(event) {
      if (this.leaveWhenEscapePressed && event.keyCode === this.escapeKeyCode && this.isVisible()) {
        event.preventDefault()
        return this._leave()
      }
    }

    _leave(e) {
      this.trigger("leave", this)
      if (e) {
        e.preventDefault()
      }
      return this.close()
    }

    _bindTo(source, event, callback) {
      source.bind(event, callback)
      return this.bindings.push({ source, event, callback })
    }

    _unbindFromAll() {
      each(this.bindings, (binding) => binding.source.unbind(binding.event, binding.callback))
      return (this.bindings = [])
    }

    // Don't let tab escape an opened lightbox
    _trapFocus(event) {
      const tabWasPressed = event.key === "Tab" || event.keyCode === 9
      if (!tabWasPressed || !this.isVisible()) return
      const focusableElements = this.$el.find(FOCUSABLE_ELEMENTS)
      const firstElement = focusableElements.first()[0]
      const lastElement = focusableElements.last()[0]
      const activeElement = document.activeElement

      // Only trap if focus is within the lightbox
      if (!this.$el[0]?.contains(activeElement)) return

      // Wrap around in either direction based on if shift is pressed or not
      const isLightboxTheActiveElement = activeElement === this.el
      const isFirstElementFocused = activeElement === firstElement
      const isFocusAtStart = isFirstElementFocused || isLightboxTheActiveElement

      if (event.shiftKey && isFocusAtStart) {
        event.preventDefault()
        $(lastElement)?.focus()
      } else if (!event.shiftKey && activeElement === lastElement) {
        event.preventDefault()
        $(firstElement)?.focus()
      }
    }
  }
  SuperLightboxView.initClass()
  return SuperLightboxView
})()
